import React, { ElementRef, useRef } from "react";

import { marketingCtaClicked } from "@utils/segment/marketingCtaClicked";
import { mxpPrimaryCtaClicked } from "@utils/mixpanelEvents/mixpanelEvents";
import ClientPractitionerDropdownMenu from "@components/Dropdowns/ClientPractitionerDropdownMenu";
import Dropdown from "@components/Dropdowns/Dropdown";

import styles from "./DropdownWithoutArrow.module.scss";

export type DropdownWithoutArrowType = {
  buttonText: string;
  buttonLink: string;
  variant: keyof typeof variantOpts;
  align?: "left" | "center" | "right";
};

const variantOpts = {
  "primary-salmon": styles.primarySalmon,
  "primary-ocean": styles.primaryOcean,
  "ghost-salmon": `${styles.ghost}`,
  "ghost-ocean": `${styles.ghost} ${styles.ghostOcean}`,
} as const;

const DropdownWithoutArrow: React.FC<DropdownWithoutArrowType> = ({
  buttonLink,
  buttonText,
  variant = "primary-salmon",
  align = "left",
}) => {
  const buttonRef = useRef<ElementRef<"button">>(null);
  const dropdownStyles = `${styles.btn} ${variantOpts[variant]}`;

  const handleClick = () => {
    mxpPrimaryCtaClicked(null!, buttonText);

    marketingCtaClicked({
      text: buttonText,
      url: window.location.pathname,
    });
  };

  return (
    <Dropdown className={styles.container}>
      <Dropdown.Button
        className={dropdownStyles}
        ref={buttonRef}
        analyticsClickEvents={handleClick}
      >
        {buttonText}
      </Dropdown.Button>

      <ClientPractitionerDropdownMenu
        align={align}
        className={styles.menu}
        clientIntent="sign_up"
        signUpUrl={buttonLink}
        withBackDrop
      />
    </Dropdown>
  );
};

export default DropdownWithoutArrow;
